import React from 'react'

import RedCardBlock from '../../components/red-card-block/RedCardBlock'
import { CardFinances, CardHeader, CardServices } from './components'
import useStyles from './Card.styles'

export default function WageAccess () {
  const classes = useStyles()

  return (
    <div>
      <CardHeader />
      <CardFinances />
      <CardServices />
      <div>
        <h2 className={classes.blueTitle}>Unlock your financial potential</h2>
      </div>
      <RedCardBlock title='Get yours today!' buttonText='Create an Account' goToPlatform />
    </div>
  )
}
